(function () {
  function init(root) {
    if (!root || root.dataset.fsInited === '1') return;
    root.dataset.fsInited = '1';

    var sectionId = root.dataset.sectionId;
    var data = (window.knucklesFinishSelector && window.knucklesFinishSelector[sectionId]) || {};
    var productForm = document.getElementById('product-form-' + sectionId);
    if (!productForm) return;
    var cards = root.querySelectorAll('.fs-card');
    if (!cards.length) return;

    function getIdInput() {
      var inputs = productForm.querySelectorAll('input[name="id"]');
      var target = null;
      inputs.forEach(function (i) { if (!i.disabled) target = i; });
      if (!target && inputs.length) target = inputs[0];
      return target;
    }

    function syncSampleFlow(variantId) {
      var sampleSize = document.getElementById('SampleFlowSizeInput-' + sectionId);
      if (!sampleSize) return;
      var target = String(variantId);
      if (sampleSize.value === target) return;
      var hasOption = Array.from(sampleSize.options).some(function (o) { return o.value === target; });
      if (!hasOption) return;
      sampleSize.value = target;
      sampleSize.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function findAddButton() {
      var section = document.getElementById('MainProduct-' + sectionId)
                 || document.getElementById('ProductInfo-' + sectionId)?.closest('section')
                 || input.closest('section');
      var btn = section && section.querySelector('button[name="add"]:not([form*="installment"])');
      return btn || document.querySelector('button[name="add"]:not([form*="installment"])');
    }

    function setButtonText(variant) {
      var btn = findAddButton();
      if (!btn || !variant) return;
      var textSpan = btn.querySelector('.single-add-to-cart-button--text');
      var priceSpan = btn.querySelector('.single-add-to-cart-button--price, [data-atc-price]');

      if (btn._sfSelectHandler) {
        btn.removeEventListener('click', btn._sfSelectHandler, true);
        btn._sfSelectHandler = null;
      }

      if (variant.available) {
        if (textSpan) textSpan.setAttribute('data-content', 'Add to basket');
        if (priceSpan) {
          priceSpan.textContent = formatMoney(variant.price);
          priceSpan.style.display = '';
        }
        btn.removeAttribute('disabled');
        btn.classList.remove('sold-out', 'disabled');
        btn.setAttribute('aria-label', 'Add to basket');
      } else {
        if (textSpan) textSpan.setAttribute('data-content', 'Sold out');
        if (priceSpan) priceSpan.textContent = '';
        btn.classList.add('sold-out');
        btn.setAttribute('aria-label', 'Sold out');
      }
    }

    function setHeaderText(variant) {
      var span = root.querySelector('[data-fs-current-variant]');
      if (!span || !variant) return;
      var text = variant.label || variant.title;
      if (text) span.textContent = text;
    }

    /* The headline price under the title is server-rendered for the first
       available variant and is normally re-rendered by the theme's own
       variant picker, which this selector bypasses. Keep it in step with
       the chosen finish so it never disagrees with the add to basket button. */
    function setHeadlinePrice(variant) {
      var priceSection = document.getElementById('price-' + sectionId);
      if (!priceSection || !variant || typeof variant.price !== 'number') return;
      var amount = priceSection.querySelector('ins .amount') || priceSection.querySelector('.amount');
      if (amount) amount.textContent = formatMoney(variant.price);
    }

    function reapplyState() {
      var sel = root.querySelector('.fs-card[data-selected="true"]');
      if (!sel) return;
      var v = data[sel.dataset.finish];
      if (v) {
        syncSampleFlow(v.id);
        setHeaderText(v);
        setButtonText(v);
        setHeadlinePrice(v);
      }
    }

    /* On load the card marked selected is decided server-side (Elixir on a
       plain product URL, or whatever ?variant= names), but the hidden form
       input still carries the first available variant. If they disagree, run
       the normal selection so the form, price and listeners follow the card. */
    function reconcileInitialSelection() {
      var sel = root.querySelector('.fs-card[data-selected="true"]');
      if (!sel) return;
      var v = data[sel.dataset.finish];
      var input = getIdInput();
      if (v && input && String(input.value) !== String(v.id)) {
        select(sel.dataset.finish);
      } else {
        reapplyState();
      }
    }

    function formatMoney(cents) {
      var amount = (cents / 100);
      var rounded = Math.round(amount * 100) / 100;
      var whole = rounded === Math.floor(rounded);
      return '£' + (whole ? rounded.toFixed(0) : rounded.toFixed(2));
    }

    function dispatch(variant) {
      var detail = { variant: variant, sectionId: sectionId };
      document.dispatchEvent(new CustomEvent('product:variant-change', { detail: detail }));
    }

    function select(finish) {
      var variant = data[finish];
      if (!variant || variant.available === false) return;

      cards.forEach(function (c) {
        var isThis = c.dataset.finish === finish;
        c.dataset.selected = isThis ? 'true' : 'false';
        c.setAttribute('aria-pressed', isThis ? 'true' : 'false');
      });
      var input = getIdInput();
      if (input) {
        input.removeAttribute('disabled');
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncSampleFlow(variant.id);
      dispatch(variant);
      setHeaderText(variant);
      setButtonText(variant);
      setHeadlinePrice(variant);
    }

    cards.forEach(function (card) {
      if (card.dataset.disabled === 'true') return;
      card.addEventListener('click', function () { select(card.dataset.finish); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          select(card.dataset.finish);
        }
      });
    });

    reconcileInitialSelection();
    setTimeout(reapplyState, 0);
    setTimeout(reapplyState, 200);
    if (document.readyState !== 'complete') {
      window.addEventListener('load', reapplyState, { once: true });
    }

    var btn = findAddButton();
    var textSpan = btn && btn.querySelector('.single-add-to-cart-button--text');
    if (textSpan && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        if (textSpan.getAttribute('data-content') === 'Select size') reapplyState();
      });
      observer.observe(textSpan, { attributes: true, attributeFilter: ['data-content'] });
    }

    var wipeSvg = root.querySelector('.fs-card[data-finish="elixir"] .fs-wipe-wrap svg');
    if (wipeSvg) animateWipe(wipeSvg);
  }

  function animateWipe(svg) {
    var cloth = svg.querySelector('.fs-cloth');
    var clothShadow = svg.querySelector('.fs-cloth-shadow');
    var marks = svg.querySelector('.fs-wipe-marks');
    if (!cloth || !marks) return;

    var pos = -30;
    var direction = 1;
    var lastFrame = 0;

    function frame(ts) {
      if (!lastFrame) lastFrame = ts;
      var dt = ts - lastFrame;
      lastFrame = ts;
      pos += direction * (dt * 0.04);

      if (pos > 96) { direction = -1; pos = 96; }
      if (pos < -30 && direction === -1) {
        direction = 1; pos = -30;
        marks.style.opacity = '0.85';
      }

      cloth.setAttribute('x', pos);
      if (clothShadow) clothShadow.setAttribute('x', pos);

      if (direction === 1 && pos > -10) {
        var progress = Math.max(0, (pos + 10) / 80);
        marks.style.opacity = String(Math.max(0, 0.85 - progress * 0.85));
      }

      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function bootstrap() {
    document.querySelectorAll('[data-finish-selector]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  document.addEventListener('shopify:section:load', bootstrap);
})();
